export default __webpack_public_path__ + "static/media/career-after-12th.332a1409.jpg";